<template>
  <div class="well page">

    <div class="row">
      <h2>{{ store.name }}</h2>
      <div id="showMsg"><!-- Error messages etc are shown here --></div>
      <span v-if="!show_history" class="pull-right">
        <button
            class="btn btn-info"
            @click="toggle_history"
        >Request History <i class="glyphicon glyphicon-list-alt"></i></button>
        <button class="btn btn-success" @click="new_job">New Request <i
            class="glyphicon glyphicon-plus"></i></button>
      </span>
      <span v-else="!show_history" class="pull-right">
        <button
            class="btn btn-info"
            @click="toggle_history"
        >Unsubmitted Requests <i class="glyphicon glyphicon-list-alt"></i></button>
        <button class="btn btn-success" @click="new_job">New Request <i
            class="glyphicon glyphicon-plus"></i></button>
      </span>
      <p v-if="!show_history">Select a request to resume or start a new maintenance request.</p>
      <p v-else>Below is a list of previously completed requests for your store. Select a request to see more details.</p>
    </div>

    <div v-if="!show_history" class="row">
      <h4>Unsubmitted Requests</h4>
      <!--<input type="search" ng-model="result" class="form-control" placeholder="Filter jobs..."/>-->
      <!--<br>-->
    </div>
    <div v-else class="row">
      <h4>Request History</h4>
    </div>

    <div v-if="!show_history" class="row">
      <div class="col-md-5" style="padding-right:0px !important">
        <!-- Saved jobs are listed here -->
        <ul>
          <li
              v-for="job in unsubmitted_jobs"
              :class="{ selected: selected_job == job }"
          >
            <a
                href=""
                @click.prevent="selected_job = job"
            >{{ format_time(job) }}</a>
          </li>
        </ul>

        <strong class="text-danger" v-if="!unsubmitted_jobs.length">No requests found</strong>
      </div>

      <div v-if="selected_job != null" class="col-md-7 jobOverview">
        <!-- Job info is shown here -->
        <div class="overviewContent">
          <button
              class="btn btn-warning"
              @click="delete_job(selected_job)"
          >Delete Job <i class="glyphicon glyphicon-trash"></i></button>
          <button
              class="btn btn-primary pull-right"
              @click="resume_job(selected_job)"
          >Resume Request <i class="glyphicon glyphicon-share-alt"></i></button>

          <h4>Total Issues:
            <small>{{ job_issues.length }}</small>
          </h4>
          <div class="row" style="padding: 3em;">
            <div
                v-for="issue in job_issues"
                class="col-md-5 col-md-offset-1 panel panel-default"
            >
              <div class="panel-body">
                <b>Type: {{ issue_type_name(issue.type) }}</b> <br>
                <i>Description: {{ issue.description }}</i> <br>
                <i v-if="issue.has_images" class="glyphicon glyphicon-picture"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-5" style="padding-right:0px !important">
        <!-- Saved jobs are listed here -->
        <ul>
          <li
              v-for="job in submitted_jobs"
              :class="{ selected: selected_job == job }"
          >
            <a
                href=""
                @click.prevent="selected_job = job"
            >{{ format_time(job) }}</a>
          </li>
        </ul>

        <strong class="text-danger" v-if="!submitted_jobs.length">No historical requests found</strong>
      </div>

      <div v-if="selected_job != null" class="col-md-7 jobOverview">
        <!-- Job info is shown here -->
        <div class="overviewContent">
          <!--<button-->
              <!--class="btn btn-warning"-->
              <!--@click="delete_job(selected_job)"-->
          <!--&gt;Delete Job <i class="glyphicon glyphicon-trash"></i></button>-->
          <!--<button-->
              <!--class="btn btn-primary pull-right"-->
              <!--@click="resume_job(selected_job)"-->
          <!--&gt;Resume Request <i class="glyphicon glyphicon-share-alt"></i></button>-->

          <h4>Total Issues:
            <small>{{ job_issues.length }}</small>
          </h4>
          <div class="row" style="padding: 3em;">
            <div
                v-for="issue in job_issues"
                class="col-md-5 col-md-offset-1 panel panel-default"
            >
              <div class="panel-body">
                <b>Type: {{ issue_type_name(issue.type) }}</b> <br>
                <i>Description: {{ issue.description }}</i> <br>
                <i v-if="issue.has_images" class="glyphicon glyphicon-picture"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  li.selected {
    background-color: rgb(238, 238, 238);
  }

  .jobOverview {
    background-color: #eee;
    padding: 2em;
  }
</style>

<script>
  import find from "lodash/find"
  import filter from "lodash/filter"

  import moment from "moment"

  export default {
    async created () {
      await this.$store.dispatch("get_stores", true);
      this.$store.commit("select_store", this.$route.params.store_id);
      this.get_jobs();
    },
    data () {
      return {
        selected_job: null,
        selected_last_job: null,
        show_history: false
      }
    },
    computed: {
      store () {
        let store = this.$store.getters.store;
        if (!store) {
          store = {id: -1, name: ""};
        }
        return store;
      },
      jobs () {
        return filter(
          this.$store.state.jobs,
          {store: this.store.id}
        );
      },
      unsubmitted_jobs () {
        return filter(this.jobs, {submitted: false});
      },
      submitted_jobs () {
        return filter(this.jobs, {submitted: true});
      },
      issues () {
        return this.$store.state.issues;
      },
      job_issues () {
        if (!this.selected_job) {
          return [];
        }
        return filter(this.issues, {job: this.selected_job.id});
      },
      issue_types () {
        return this.$store.state.issue_types;
      }
    },
    methods: {
      get_jobs () {
        return [
          this.$store.dispatch("get_jobs", {store_id: this.store.id}),
          this.$store.dispatch("get_issues", {
            store_id: this.store.id
          })
        ];
      },
      format_time (job) {
        return moment(job.creation_time).format("dddd, MMMM D, YYYY");
      },
      async delete_job (job) {
        await this.$store.dispatch("delete_job", job);
        this.selected_job = null;
      },
      resume_job (job) {
        this.$router.push({
          name: "job-logger",
          params: {job_id: job.id}
        });
      },
      async new_job () {
        let job = await this.$store.dispatch("new_job", {store: this.store.id});
        this.resume_job(job);
      },
      issue_type_name (type) {
        let it = find(this.issue_types, {id: type});
        if (!it) {
          return "Unknown Issue Type"
        }
        return it.name;
      },
      toggle_history () {
        this.show_history = !this.show_history;
        [this.selected_job, this.selected_last_job] = [this.selected_last_job, this.selected_job];
      }
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/StoreJobs.vue?e6b4caf8